(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-explorer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__fxInit) return;
    window.__fxInit = true;

    function wire(scope) {
      var btns = Array.prototype.slice.call(scope.querySelectorAll('[data-filter]'));
      var items = Array.prototype.slice.call(scope.querySelectorAll('[data-fx-item]'));
      var empty = scope.querySelector('.fx__empty');

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-filter');
          btns.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          var shown = 0;
          items.forEach(function (it) {
            var tags = ' ' + (it.getAttribute('data-tags') || '') + ' ';
            var show = val === 'all' || tags.indexOf(' ' + val + ' ') !== -1;
            it.classList.toggle('fx-hidden', !show);
            if (show) shown++;
          });
          if (empty) empty.hidden = shown !== 0;
        });
      });
    }

    document.querySelectorAll('[data-filter-scope]').forEach(wire);

    var goal = new URLSearchParams(window.location.search).get('goal');
    if (goal) {
      var sel = (window.CSS && CSS.escape) ? CSS.escape(goal) : goal;
      document.querySelectorAll('[data-filter-scope]').forEach(function (scope) {
        var b = scope.querySelector('[data-filter="' + sel + '"]');
        if (b) b.click();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["court-mode"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cm]');
    if (!root) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Rotating hero promise
    root.querySelectorAll('[data-cm-rotator]').forEach(function (rotator) {
      var words = Array.prototype.slice.call(rotator.querySelectorAll('.cm-title__word'));
      if (reduce || words.length < 2) return;
      var active = 0;
      window.setInterval(function () {
        var current = words[active];
        active = (active + 1) % words.length;
        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        words[active].classList.remove('is-leaving');
        words[active].classList.add('is-active');
        window.setTimeout(function () { current.classList.remove('is-leaving'); }, 600);
      }, 2400);
    });

    // Scroll parallax
    var pars = Array.prototype.slice.call(root.querySelectorAll('[data-cm-par]'));
    var ticking = false;
    function onScroll() {
      if (ticking || reduce) return;
      ticking = true;
      requestAnimationFrame(function () {
        var vh = window.innerHeight;
        pars.forEach(function (el) {
          var r = el.getBoundingClientRect();
          var mid = r.top + r.height / 2;
          var rel = (mid - vh / 2) / vh; // -1..1 ish
          var f = parseFloat(el.getAttribute('data-cm-par')) || 0;
          el.style.transform = 'translate3d(0,' + (rel * f * 100).toFixed(1) + 'px,0)';
        });
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Reveal on enter
    var targets = root.querySelectorAll('.cm-hero__copy, .cm-float__copy, .cm-float__art, .cm-stat, .cm-closer__inner, .cm-h2');
    targets.forEach(function (t) { t.setAttribute('data-cm-reveal', ''); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.15 });
      targets.forEach(function (t) { io.observe(t); });
    } else {
      targets.forEach(function (t) { t.classList.add('is-in'); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-explorer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__fxInit) return;
    window.__fxInit = true;

    function wire(scope) {
      var btns = Array.prototype.slice.call(scope.querySelectorAll('[data-filter]'));
      var items = Array.prototype.slice.call(scope.querySelectorAll('[data-fx-item]'));
      var empty = scope.querySelector('.fx__empty');

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-filter');
          btns.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          var shown = 0;
          items.forEach(function (it) {
            var tags = ' ' + (it.getAttribute('data-tags') || '') + ' ';
            var show = val === 'all' || tags.indexOf(' ' + val + ' ') !== -1;
            it.classList.toggle('fx-hidden', !show);
            if (show) shown++;
          });
          if (empty) empty.hidden = shown !== 0;
        });
      });
    }

    document.querySelectorAll('[data-filter-scope]').forEach(wire);

    var goal = new URLSearchParams(window.location.search).get('goal');
    if (goal) {
      var sel = (window.CSS && CSS.escape) ? CSS.escape(goal) : goal;
      document.querySelectorAll('[data-filter-scope]').forEach(function (scope) {
        var b = scope.querySelector('[data-filter="' + sel + '"]');
        if (b) b.click();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
